import React from 'react';
import { Row, Col } from 'react-bootstrap';
import { MainComponentBox, navTo } from '../../../util/util.jsx';
import { connect } from 'react-redux';
import Deals from './Deals.jsx';
import { List } from 'immutable';
import './deals.less';
import { DealButtonsContainer, PaymentsButtonsContainer,
  NewDealButtons, COVButtonsContainer } from './DealButtons.jsx';
import PaymentsArea from './payments/PaymentsArea.jsx';
import CommonPaymentsArea from './payments/CommonPaymentsArea.jsx';
import { validateRoleConfig } from '../../auth/RoleConfigFilter.jsx';

function getDealType(state) {
  const pathname = state
    .getIn(['routing', 'locationBeforeTransitions', 'pathname'])
    .match(/\/deals\/([a-z]+)(\/.*)?$/);
  if (pathname) {
    return pathname[1];
  }
  return 'purchase';
}

function getLinkTo(state) {
  const pathname = state
    .getIn(['routing', 'locationBeforeTransitions', 'pathname'])
    .match(/\/deals\/(.*linkto)\/(.*)$/);
  if (pathname) {
    return pathname[2];
  }
  return null;
}

const mapStateToPropsForContainer = (state) => {
  const dealType = getDealType(state);
  const linkTo = getLinkTo(state);
  return {
    dealType,
    linkTo,
    selectedView: state.getIn(['routing', 'locationBeforeTransitions', 'pathname'])
      .split('/').pop(),
    roles: state.getIn(['session', 'roles'], new List()),
    useMobileVersion: state.getIn(['allaround', 'useMobileVersion'], true),
  };
};

const getSecondNavBar = (props) => {
  switch (props.selectedView) {
    case 'inpayments':
    case 'outpayments':
    case 'commonpayments':
    case 'closedpayments':
    case 'counterpartyoutstanding': {
      if (validateRoleConfig(['financesViewEditDelete', 'myPaymentsView', 'viewPayments'])) {
        return <PaymentsButtonsContainer selectedView={props.selectedView} />;
      }
      break;
    }
    case 'transport': {
      if (validateRoleConfig(['myTransports#1', 'allTransports#1'])) {
        return <DealButtonsContainer selectedView={props.selectedView} />;
      }
      break;
    }
    case 'counterpartyoutstandingvalues': {
      return <COVButtonsContainer back={() => navTo('/deals/counterpartyoutstanding')} />;
    }
    default:
      if (validateRoleConfig(['myDeals#1', 'allDeals#1', 'viewDealsByRegion'])) {
        return <DealButtonsContainer selectedView={props.selectedView} />;
      }
  }
  return <div />;
};
getSecondNavBar.propTypes = {
  roles: React.PropTypes.oneOfType([React.PropTypes.object, React.PropTypes.string]),
  selectedView: React.PropTypes.string,
};

class DealsContainer extends React.Component {
  constructor(props) {
    super(props);
    this.handleResize = this.handleResize.bind(this);
    this.state = { showFullVersion: false };
  }

  componentDidMount() {
    window.addEventListener('resize', this.handleResize);
    this.handleResize();
  }

  componentWillReceiveProps(props) {
    if (this.props.useMobileVersion != props.useMobileVersion) {
      this.handleResize(props);
    }
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.handleResize);
  }
  handleResize(props = this.props) {
    const width = document.documentElement.clientWidth;
    let showFullVersion = true;
    if (width <= 480 && props.useMobileVersion) {
      showFullVersion = false;
    }
    if (showFullVersion != this.state.showFullVersion) {
      this.setState({ showFullVersion });
    }
  }

  render() {
    return (
      <MainComponentBox
        secondNavBar={getSecondNavBar(this.props)}
        colStyle={{ paddingTop: 10 }}
        wide
        className={`${this.props.selectedView}-container`}
      >
        <Row>
          <Col md={12}>
            <NewDealButtons />
            {this.state.showFullVersion && this.props.children}
          </Col>
        </Row>
      </MainComponentBox>);
  }
}

DealsContainer.propTypes = {
  children: React.PropTypes.oneOfType([
    React.PropTypes.arrayOf(React.PropTypes.node),
    React.PropTypes.node,
  ]),
  dealType: React.PropTypes.string.isRequired,
  linkTo: React.PropTypes.string,
  selectedView: React.PropTypes.string,
  roles: React.PropTypes.oneOfType([React.PropTypes.object, React.PropTypes.string]),
  useMobileVersion: React.PropTypes.bool,
  style: React.PropTypes.object,

};

export default connect(mapStateToPropsForContainer)(DealsContainer);

const PurchaseArea = () => <Deals type="purchase" />;
const SaleArea = () => <Deals type="sale" />;
const TransportArea = () => <Deals type="transport" />;

export const Purchase = () => <PurchaseArea />;

export const Transport = () => <TransportArea />;

export const Sale = () => <SaleArea />;

export const Unlinked = () => <Deals type="unlinked" />;

export const Payments = (props) => <PaymentsArea
  isPlus={props.route && props.route.isPlus} isClosed={props.route && props.route.isClosed}
/>;

Payments.propTypes = {
  route: React.PropTypes.object,
};

export const CommonPayments = () => <CommonPaymentsArea />;
